export default __webpack_public_path__ + "static/media/silver_medal.6e60cd90.svg";